import { urlPagamentoSegura } from './pagamentoUrl';

/**
 * Os três desfechos são distintos porque a mensagem ao usuário é distinta:
 * "o link não é do gateway" é problema nosso, "libere os pop-ups" é ação dele.
 */
export type ResultadoCheckout = 'ABERTO' | 'POPUP_BLOQUEADO' | 'URL_INVALIDA';

/**
 * Abre o checkout do gateway numa aba nova e diz **se a aba realmente abriu**.
 *
 * Existe porque `window.open(url, '_blank', 'noopener')` devolve `null` mesmo
 * quando a aba abre: pedir `noopener` na string de features significa que não há
 * relação de opener, e a spec manda retornar `null`. Testar esse retorno para
 * detectar pop-up bloqueado dá **falso positivo em todo pagamento bem-sucedido**
 * — o usuário lê "não conseguimos abrir o pagamento" com o checkout aberto ao
 * lado, e no card de custas a cobrança nem sequer entra em espera.
 *
 * O padrão que funciona é o mesmo de `negociacaoSelf/hooks/useNegociacaoSelf`:
 * abrir em branco (sem features), anular `opener` na mão — o que dá a mesma
 * proteção que `noopener` daria — e só então navegar.
 *
 * O guard de host continua valendo: a URL vem da API, e uma resposta adulterada
 * não pode virar redirect para fora do gateway.
 *
 * @example
 * const r = abrirCheckoutPagamento(cobranca.linkPagamento);
 * if (r === 'POPUP_BLOQUEADO') toast.showError('…', 'Nada foi cobrado.');
 */
export function abrirCheckoutPagamento(url: string | null | undefined): ResultadoCheckout {
  if (!urlPagamentoSegura(url)) return 'URL_INVALIDA';

  const aba = window.open('', '_blank');
  if (!aba) return 'POPUP_BLOQUEADO';

  aba.opener = null;
  aba.location.href = url;
  return 'ABERTO';
}
